stimulusApp.register(
  "flow-transition",
  class extends Stimulus.Controller {
    static morphingClass = "help-centre-flow_morphing"

    animate(event) {
      if (event.target !== this.element) return
      if (typeof document.startViewTransition !== "function") return
      if (window.matchMedia?.("(prefers-reduced-motion: reduce)")?.matches)
        return

      const render = event.detail.render
      event.detail.render = (currentElement, newElement) => {
        this.element.classList.add(this.constructor.morphingClass)
        const transition = document.startViewTransition(() =>
          render(currentElement, newElement),
        )
        // A skipped transition (hidden tab, superseded navigation) still
        // applies the swap but rejects `ready`; swallow the aborts.
        transition.ready.catch(() => {})
        transition.finished
          .finally(() => {
            this.element.classList.remove(this.constructor.morphingClass)
          })
          .catch(() => {})
      }
    }
  },
)
